import React, { useState, useEffect } from 'react';
import './style.css';
import { boardServices } from '../../api';
import { removeOfflineData } from '../../utils/helper';
import { useParams } from 'react-router-dom';
import { useDocument } from '../../context/documentInfoContex';
import { emitRoomID, emitUpdateAll } from '../../socket';

const OfflineStatus = () => {

    const { id } = useParams();
    const { setSavingData, setIsConflictModalVisible, setServerData } = useDocument();
    const [offline, setOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOfflineStatus = async () => {

            const isOnline = navigator.onLine;
            setOffline(!isOnline);

            const offlineBoard = JSON.parse(localStorage.getItem("offlineIdeationData") || "{}");
            const localData = offlineBoard[id]?.data || null;
            const localDate = offlineBoard[id]?.lastUpdateTime ? new Date(offlineBoard[id].lastUpdateTime) : null;


            if (isOnline && localData) {
                try {

                    const serverBoardData = await boardServices.getBoardData(id);
                    const serverCanvasData = serverBoardData?.mileboardData?.[0] || null;
                    const serverDate = serverBoardData?.updatedAt ? new Date(serverBoardData.updatedAt) : null;
                    setServerData(serverBoardData);

                    // Conflict check
                    if (serverCanvasData && serverDate && localDate && serverDate > localDate) {
                        setIsConflictModalVisible(true);
                        return;
                    }

                    // Auto-sync if no conflict
                    else {
                        await boardServices.updateBoardData(id, localData, setSavingData);
                        removeOfflineData(id);
                        emitUpdateAll({ roomID: id, data: { message: "offline version loaded" } });
                        emitRoomID(id);
                    }
                } catch (e) {
                    console.error('Error during offline sync:', e);
                }
            }
        };

        // Initial check
        handleOfflineStatus();

        window.addEventListener('offline', handleOfflineStatus);
        window.addEventListener('online', handleOfflineStatus);

        return () => {
            window.removeEventListener('offline', handleOfflineStatus);
            window.removeEventListener('online', handleOfflineStatus);
        };

    }, [id, setSavingData]);

    if (!offline) return null;

    return (
        <div className="offlineStatus">
            <div>
                No internet? No problem! You're working offline — we’ll sync up when you're reconnected.
            </div>
        </div>
    );
};

export default OfflineStatus;